export default "__VITE_ASSET__COdsGBpG__"